module.exports = __webpack_public_path__ + "static/media/photo_cam.274270b2.png";